export const addToPrev = (payload) => {
  return {
    type: "AddToPrev",
    payload: payload,
  };
};
